import React from "react";

const Home = () => {
  return (
    <div className="welcome-container">
      <p>Hello!Check Concerts Records :)...</p>
    </div>
  );
};

export default Home;
